<template>
  <div>
    <Banner bgsrc="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_banner1.png">
      <span class="w-banner_text">{{ this.$t('dSCircularPackaging.dSCircularPackagingTitle') }}</span>
    </Banner>
    <div class="w-packaging_issues">
      <XYTitle xText="ISSUES"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-issues_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSCircularPackaging.doYouHaveTheseTroubles') }}</h4>
          <span>ISSUES</span>
        </div>
      </Animation>
      <div class="w-issues_box">
        <div v-for="item,index in issuesList" :key="index">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-issues_item">
              <div class="w-issues_item_title">
                <span></span>
                <span class="w-button_text">{{ item.title }}</span>
              </div>
              <div class="w-paragraph_text w-issues_item_text">{{ item.text }}</div>
            </div>
          </Animation>
        </div>
      </div>
    </div>
    <div class="w-packaging_management">
      <div class="w-management_leftBox">
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <div v-for="item,index in managementList" :key="index" class="w-leftBox_outer">
            <div class="w-leftBox_title" @click="handOpenManagment(item)">
              <span class="w-title_text">{{ item.managementName }}</span>
              <span class="w-title_icon" :class="{'w-icon_rotate':managmentIsActive==item.managementId}"><i class="iconfont icon-icon_close"></i></span>
            </div>
            <template v-if="managmentIsActive==item.managementId">
              <div v-for="child,cIndex in item.children" :key="cIndex" class="w-leftBox_item w-transform_timing" @click="handOpenChildren(child)">
                <span :class="{'w-icon_activeText':managmentIsActiveImg==child.managementId}">{{ child.managementName }}</span>
                <i class="w-button_text iconfont icon-common_icon_more"></i>
              </div>
            </template>
          </div>
        </Animation>
      </div>
      <div class="w-management_rightBox">
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <img v-if="lang=='zh'" :src="`https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_management_${managmentIsActiveImg}.png`" alt="" style="cursor: pointer;" id="zoom-image">
          <img v-else-if="lang=='en'" :src="`https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/belgium/images/solution_img_${managmentIsActiveImg}.png`" alt="" style="cursor: pointer;" id="zoom-image">
        </Animation>
      </div>
    </div>
    <div class="w-packaging_management2">
      <div v-for="item,index in managementList" :key="index">
        <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
          <div class="w-management2_title">{{ item.managementName }}</div>
        </Animation>
        <div class="w-management2_content">
          <div v-for="child,cIndex in item.children" :key="cIndex" class="w-management2_item">
            <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
              <img v-if="lang=='zh'" :src="`https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_management_${managmentIsActiveImg}.png`" alt="" style="cursor: pointer;" class="management2_zoom-image">
              <img v-else-if="lang=='en'" :src="`https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/belgium/images/solution_img_${managmentIsActiveImg}.png`" alt="" style="cursor: pointer;" class="management2_zoom-image">
              <span class="w-management2_item_text">{{ child.managementName }}</span>
            </Animation>
          </div>
        </div>
      </div>
    </div>
    <div class="w-packaging_solutions">
      <XYTitle xText="SOLUTIONS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-solutions_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSCircularPackaging.weWillProvideYouWithProfessionalSolutions') }}</h4>
          <span>SOLUTIONS</span>
        </div>
      </Animation>
      <div class="w-solutions_box">
        <div class="w-solutions_left">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-smallTitle_text">{{ this.$t('dSCircularPackaging.digitalSystemForZhituoVehicles') }}</div>
          </Animation>
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-paragraph_text">{{ this.$t('dSCircularPackaging.solutionsText') }}</div>
          </Animation>
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-solutions_title_text">
              <div><span class="w-nonParagraph_text">{{ this.$t('dSCircularPackaging.solutionsText1') }}</span></div>
              <div><span class="w-nonParagraph_text">{{ this.$t('dSCircularPackaging.solutionsText2') }}</span></div>
              <div><span class="w-nonParagraph_text">{{ this.$t('dSCircularPackaging.solutionsText3') }}</span></div>
              <div><span class="w-nonParagraph_text">{{ this.$t('dSCircularPackaging.solutionsText4') }}</span></div>
            </div>
          </Animation>
        </div>
        <div class="w-solutions_right">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <video v-if="lang=='zh'" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_video.mp4" controls></video>
            <video v-if="lang=='en'" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/Products%20Video.mp4" controls></video>
          </Animation>
        </div>
      </div>
    </div>
    <div class="w-packaging_advantage">
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-advantage_contant">
          <div v-for="item,index in advantageList" :key="index" class="w-advantage_item">
            <i :class="['iconfont',item.iconfont ]"></i>
            <div class="w-smallTitle_text">{{ item.title }}</div>
            <div class="w-paragraph_text">{{ item.value }}</div>
          </div>
        </div>
      </Animation>
    </div>
    <div class="w-packaging_architecture">
      <XYTitle xText="ARCHITECTURE"></XYTitle>
      <div class="w-moduleBanner_text w-architecture_title">{{ this.$t('dSCircularPackaging.architectureTitle') }}</div>
      <div class="w-architecture_img">
        <img v-if="lang=='zh'" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_1.png" alt="">
        <img v-if="lang=='en'" src="https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_1.png" alt="">
      </div>
    </div>
    <div class="w-packaging_highlights">
      <XYTitle xText="HIGHLIGHTS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-highlights_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSCircularPackaging.highlightsTitle') }}</h4>
          <span>{{ this.$t('dSCircularPackaging.highlightsText') }}</span>
        </div>
      </Animation>
      <div class="w-highlights_list">
        <div v-for="item,index in highlightsList" :key="index">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-highlights_item">
              <div class="w-item_img">
                <img :src="lang=='zh'?item.url:item.urlEn" alt="#">
              </div>
              <div class="w-item_title w-bigTitle_text">
                {{ item.title }}
              </div>
              <div class="w-item_text w-paragraph_text">
                {{ item.text }}
              </div>
            </div>
          </Animation>
        </div>
      </div>
    </div>
    <div class="w-packaging_scenarios">
      <XYTitle xText="APPLICATION SCENARIOS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-scenarios_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSCircularPackaging.scenariosTitle') }}</h4>
          <span class="w-paragraph_text">{{ this.$t('dSCircularPackaging.scenariosText') }}</span>
        </div>
      </Animation>
      <div class="w-scenarios_box">
        <div v-for="item,index in scenariosList" :key="index">
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-box_imgbox">
              <img :src="item.url" alt="#">
            </div>
          </Animation>
          <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
            <div class="w-nonParagraph_text w-box_label">
              {{ item.label }}
            </div>
          </Animation>
        </div>
      </div>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-scenarios_text">“{{this.$t('dSCircularPackaging.scenariosText1')}}”</div>
      </Animation>
    </div>
    <div class="w-packaging_locators">
      <XYTitle xText="LOCATORS"></XYTitle>
      <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
        <div class="w-locators_title">
          <h4 class="w-moduleBanner_text">{{ this.$t('dSCircularPackaging.locatorsTitle') }}</h4>
        </div>
      </Animation>
      <div class="w-locators_list">
        <div class="w-list_box w-product_hover">
          <div v-for="(item, index) in locatorsList" class="hover_box" :key="index" @click="handProduct(item.productName)">
            <Animation defaultClass="w-transform_top" animationClass="w-transform_show">
              <img :src="item.src" alt="" />
              <div class="w-box_div">
                <div class="w-hover_move">
                  <span class="w-bigTitle_text w_xuyu">{{ item.productName }}</span>
                  <div class="w_aboutUsMore w-transform_timing">
                    <span class="w-button_text">{{item.viewMore}}</span>
                    <i class="iconfont icon-common_icon_more w-button_text"></i>
                  </div>
                </div>
              </div>
            </Animation>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Banner from '@/components/Banner'
import XYTitle from '@/components/XYTitle.vue'
import Animation from '@/components/Animation.vue'
import Footer from '@/components/Footer.vue'
import Viewer from 'viewerjs';
export default {
  props: {

  },
  data () {
    return {
      lang: localStorage.getItem('lang') || 'zh',
      issuesList: [{
        id: 1,
        title: this.$t('dSCircularPackaging.issuesItemtitle1'),
        text: this.$t('dSCircularPackaging.issuesItemtext1')
      }, {
        id: 2,
        title: this.$t('dSCircularPackaging.issuesItemtitle2'),
        text: this.$t('dSCircularPackaging.issuesItemtext2')
      }, {
        id: 3,
        title: this.$t('dSCircularPackaging.issuesItemtitle3'),
        text: this.$t('dSCircularPackaging.issuesItemtext3')
      }, {
        id: 4,
        title: this.$t('dSCircularPackaging.issuesItemtitle4'),
        text: this.$t('dSCircularPackaging.issuesItemtext4')
      }, {
        id: 5,
        title: this.$t('dSCircularPackaging.issuesItemtitle5'),
        text: this.$t('dSCircularPackaging.issuesItemtext5')
      },
      ],
      advantageList: [{
        iconfont: 'icon-solution_icon_solu1',
        title: this.$t('dSCircularPackaging.advantageItemTitle1'),
        value: this.$t('dSCircularPackaging.advantageItemText1')
      }, {
        iconfont: 'icon-solution_icon_solu2',
        title: this.$t('dSCircularPackaging.advantageItemTitle2'),
        value: this.$t('dSCircularPackaging.advantageItemText2')
      }, {
        iconfont: 'icon-solution_icon_solu3',
        title: this.$t('dSCircularPackaging.advantageItemTitle3'),
        value: this.$t('dSCircularPackaging.advantageItemText3')
      }, {
        iconfont: 'icon-solution_icon_solu4',
        title: this.$t('dSCircularPackaging.advantageItemTitle4'),
        value: this.$t('dSCircularPackaging.advantageItemText4')
      },
      ],
      managmentIsActive: 1,
      managmentIsActiveImg: 1,
      managementList: [
        {
          managementName: this.$t('dSCircularPackaging.fullProcessManagement'),
          managementId: 1,
          children: [{
            managementName: this.$t('dSCircularPackaging.independentTrackerFullProcessTracking'),
            managementId: 1
          }, {
            managementName: this.$t('dSCircularPackaging.nearFieldFullProcessManagement'),
            managementId: 2
          }, {
            managementName: this.$t('dSCircularPackaging.fullProcessManagementOfInWarehouseAndOffSiteTransportation'),
            managementId: 3
          }]
        }, {
          managementName: this.$t('dSCircularPackaging.regionalManagement'),
          managementId: 2,
          children: [{
            managementName: this.$t('dSCircularPackaging.staticInventoryInTheWarehouse'),
            managementId: 4
          }, {
            managementName: this.$t('dSCircularPackaging.warehouseToWarehouseStocktake'),
            managementId: 5
          }, {
            managementName: this.$t('dSCircularPackaging.inventoryOfColdStorageLogisticCarriersUtilizationRate'),
            managementId: 6
          }]
        }, {
          managementName: this.$t('dSCircularPackaging.meterLevelPositioning'),
          managementId: 3,
          children: [{
            managementName: this.$t('dSCircularPackaging.productsLogisticsRealTimeMeterLevelPositioningAndOffSiteCirculation'),
            managementId: 7
          }, {
            managementName: this.$t('dSCircularPackaging.meterLevelHighPrecisionCargoSearchInTheWarehouse'),
            managementId: 8
          }, {
            managementName: this.$t('dSCircularPackaging.inventoryInMultipleAreasOfSingleWarehouses'),
            managementId: 9
          }]
        }
      ],
      highlightsList: [{
        id: 1,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight1.png',
        urlEn: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_highlight1.png',
        title: this.$t('dSCircularPackaging.highlightsItemTitle1'),
        text: this.$t('dSCircularPackaging.highlightsItemText1')
      }, {
        id: 2,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight2.png',
        urlEn: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_highlight2.png',
        title: this.$t('dSCircularPackaging.highlightsItemTitle2'),
        text: this.$t('dSCircularPackaging.highlightsItemText2')
      }, {
        id: 3,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight3.png',
        urlEn: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_highlight3.png',
        title: this.$t('dSCircularPackaging.highlightsItemTitle3'),
        text: this.$t('dSCircularPackaging.highlightsItemText3')
      }, {
        id: 4,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight4.png',
        urlEn: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_highlight4.png',
        title: this.$t('dSCircularPackaging.highlightsItemTitle4'),
        text: this.$t('dSCircularPackaging.highlightsItemText4')
      }, {
        id: 5,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight5.png',
        urlEn: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_highlight5.png',
        title: this.$t('dSCircularPackaging.highlightsItemTitle5'),
        text: this.$t('dSCircularPackaging.highlightsItemText5')
      }, {
        id: 6,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight6.png',
        urlEn: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_highlight6.png',
        title: this.$t('dSCircularPackaging.highlightsItemTitle6'),
        text: this.$t('dSCircularPackaging.highlightsItemText6')
      }, {
        id: 7,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight7.png',
        urlEn: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_highlight7.png',
        title: this.$t('dSCircularPackaging.highlightsItemTitle7'),
        text: this.$t('dSCircularPackaging.highlightsItemText7')
      }, {
        id: 8,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_highlight8.png',
        urlEn: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/belgium/solution_img_highlight8.png',
        title: this.$t('dSCircularPackaging.highlightsItemTitle8'),
        text: this.$t('dSCircularPackaging.highlightsItemText8')
      }],
      scenariosList: [{
        id: 1,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application1.png',
        label: this.$t('dSCircularPackaging.scenariosItemLabel1'),
      }, {
        id: 2,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application2.png',
        label: this.$t('dSCircularPackaging.scenariosItemLabel2'),
      }, {
        id: 3,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application3.png',
        label: this.$t('dSCircularPackaging.scenariosItemLabel3'),
      }, {
        id: 4,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application4.png',
        label: this.$t('dSCircularPackaging.scenariosItemLabel4'),
      }, {
        id: 5,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application5.png',
        label: this.$t('dSCircularPackaging.scenariosItemLabel5'),
      }, {
        id: 6,
        url: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/solution/solution_img_application6.png',
        label: this.$t('dSCircularPackaging.scenariosItemLabel6'),
      }],
      locatorsList: [{
        id: 1,
        src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product1.png',
        productName: 'D98',
        viewMore: this.$t('home.viewMore')
      }, {
        id: 2,
        src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product2.png',
        productName: 'D96',
        viewMore: this.$t('home.viewMore')
      }, {
        id: 3,
        src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product3.png',
        productName: 'D92',
        viewMore: this.$t('home.viewMore')
      }, {
        id: 4,
        src: 'https://xuyuweb.oss-cn-shanghai.aliyuncs.com/productOfficial/images/common/common_img_product6.png',
        productName: this.$t('home.productBlueTooth'),
        viewMore: this.$t('home.viewMore')
      }]
    };
  },
  mounted () {
    this.imageZoom()

  },
  methods: {
    handProduct (data) {
      //点击产品
      this.$emit('openProdect', { activeId: 2, menuName: 'ProductDetail', prodectId: data })
    },
    handOpenManagment (event) {
      const { managementId } = event
      if (this.managmentIsActive == managementId)      {
        this.managmentIsActive = 0
      } else      {
        this.managmentIsActive = managementId
      }
    },
    handOpenChildren (event) {//切换数据
      this.managmentIsActiveImg = event.managementId
    },
    imageZoom (data) {
      this.$nextTick(() => {
        const viewer = new Viewer(document.getElementById('zoom-image'), {
          navbar: false,
          inline: false,
          toolbar: false,
          fullscreen: true,
          title: false,
          zoomRatio: 0.1,
          minZoomRatio: 0.1,
          maxZoomRatio: 1.2
        });
        let imgList = document.querySelectorAll('.management2_zoom-image')
        imgList.forEach(item => {
          new Viewer(item, {
            navbar: false,
            inline: false,
            toolbar: false,
            fullscreen: true,
            title: false,
            zoomRatio: 0.1,
            minZoomRatio: 0.1,
            maxZoomRatio: 1.2
          })
        })
      })
    },
  },
  components: {
    Banner, XYTitle, Animation, Footer
  },
};
</script>

<style  lang="scss">
.viewer-container .viewer-close {
  width: 33.33px;
  height: 33.33px;
  flex-shrink: 0;
  fill: #00000033;
  color: #ffffff;
  top: 19px;
  right: 19px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.viewer-close::before {
  position: static;
}
</style>
